<template>
  <div
    class="w-full cursor-pointer px-4 py-2 flex tablet-h:rounded-[10px] tablet-h:p-1.5 tablet-h:pr-2.5"
    :class="classes"
    @click="handleRowClick"
  >
    <div class="mr-[9px] size-11 shrink-0 p-0.5">
      <div
        class="flex size-full items-center justify-center rounded-full bg-red-700/10"
      >
        <AlertIcon class="size-5 text-red-700" />
      </div>
    </div>
    <div
      class="text-[14px] leading-[19px] text-gray-800 -mt-1 flex flex-col justify-between"
    >
      <component :is="copy" class="mb-[3px]" />
      <div class="text-[12px] leading-[18px] opacity-60">
        {{ formatDistanceToNowStrict(props.notification.timestamp) }} ago
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  NotificationType,
  type Notification,
} from '@/shared/graphql/legacy/generated'
import { AlertIcon } from '@dacr/icons'
import { formatDistanceToNowStrict } from 'date-fns'
import { computed, h } from 'vue'
import { useRouter } from 'vue-router'

const props = defineProps<{
  notification: Notification
}>()

const router = useRouter()

const handleRowClick = () => {
  router.push('/settings/billing')
}

const classes = computed(() => ({
  'tablet-h:hover:bg-[#FAFAFA]': props.notification.read,
  'bg-green-700/10': !props.notification.read,
}))

const copy = computed(() => {
  if (
    props.notification.type === NotificationType.SubscriptionDowngradeFailed
  ) {
    return h('div', [
      'Your plan change was canceled due to your account exceeding the file limit of your new plan.',
    ])
  }

  return null
})
</script>
